var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoHammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.97345C0 7.42157 0 7.14563 0.0740273 6.89151C0.139601 6.66641 0.247366 6.4547 0.392027 6.26677C0.555337 6.05461 0.782021 5.8852 1.23539 5.54638L8.0177 0.477696C8.36902 0.215138 8.54468 0.0838583 8.73865 0.0333949C8.9098 -0.0111316 9.0902 -0.0111316 9.26135 0.0333949C9.45532 0.0838583 9.63098 0.215138 9.98231 0.477697L16.7646 5.54638C17.218 5.8852 17.4447 6.05461 17.608 6.26677C17.7526 6.4547 17.8604 6.66641 17.926 6.89151C18 7.14563 18 7.42157 18 7.97345V14.9252C18 16.0015 18 16.5396 17.782 16.9507C17.5903 17.3123 17.2843 17.6063 16.908 17.7905C16.4802 18 15.9201 18 14.8 18H3.2C2.0799 18 1.51984 18 1.09202 17.7905C0.715695 17.6063 0.409734 17.3123 0.217987 16.9507C0 16.5396 0 16.0015 0 14.9252V7.97345Z",
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_415_192363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.77614 14 10 14.2239 10 14.5C10 14.7762 9.77614 15 9.5 15H4.5C4.22386 15 4 14.7762 4 14.5C4 14.2239 4.22386 14 4.5 14H9.5ZM10.0892 4.54694C10.2018 4.43433 10.3843 4.43429 10.4968 4.54687L13.9785 8.02856C14.0909 8.14095 14.091 8.32315 13.9787 8.43562L13.6726 8.74218C13.5515 8.8634 13.3723 8.90572 13.2098 8.85145C13.0475 8.79725 12.8685 8.8394 12.7475 8.96031L11.7065 10L14.1815 12.475C14.3767 12.6703 14.3767 12.9868 14.1815 13.182C13.9863 13.3772 13.6697 13.3772 13.4745 13.182L11 10.707L10.0042 11.7028C9.87628 11.8307 9.82485 12.0164 9.86874 12.192C9.91263 12.3676 9.86115 12.5533 9.73311 12.6813L9.44859 12.9656C9.32896 13.0851 9.13507 13.0851 9.01548 12.9655L5.55982 9.50984C5.44009 9.3901 5.44012 9.19597 5.5599 9.07627L5.84458 8.7918C5.97235 8.66412 6.1577 8.61277 6.33295 8.65651C6.50826 8.70025 6.69366 8.64887 6.82143 8.52112L9.56494 5.77805C9.68602 5.65699 9.72833 5.47791 9.67423 5.31545C9.62015 5.15307 9.6624 4.97406 9.78338 4.85299L10.0892 4.54694ZM11.3536 6.81827C10.9631 6.42768 10.3299 6.42761 9.93929 6.81812L7.81811 8.93901C7.42757 9.32949 7.42751 9.96261 7.81796 10.3532L8.17144 10.7068C8.56193 11.0974 9.19514 11.0974 9.58571 10.7069L11.7069 8.58602C12.0974 8.19555 12.0975 7.56242 11.707 7.17186L11.3536 6.81827Z",
    fill: "url(#paint0_linear_415_192363)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_415_192363",
    x: 3,
    y: 3.4624,
    width: 14.3279,
    height: 14.5376,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_192363"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_192363",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_192363",
    x1: 4,
    y1: 4.34302,
    x2: 14.715,
    y2: 4.52716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoHammer);
export default __webpack_public_path__ + "static/media/OneoHammer.5dad49208716ad61d9f7a802b46bb8a7.svg";
export { ForwardRef as ReactComponent };